// KAN-552 follow-up: who may use the internal test-run page (/admin/test-runs).
// Admins, plus accounts the server lists in TEST_RUNNER_EMAILS — it reports that as
// `can_enter_test_runs` on the signed-in user's own record (login and /users/me).
// The server enforces the same rule on the page's three routes; this only decides what to show.
export function canEnterTestRuns(user) {
  if (!user) return false;
  return user.role === 'admin' || user.can_enter_test_runs === true;
}
